












import {
  Component,
  Prop,
  Vue,
  Watch,
  Model,
  Emit
} from "vue-property-decorator";
import E from "wangeditor";
import { Icon } from "vant";
import Native from "@/common/Native";
import axios from "axios";
@Component({
  components: {
    [Icon.name]: Icon
  }
})
export default class extends Vue {
  editor: any = null;
  isChange: boolean = false;
  @Prop({ default: "" }) content!: string;
  @Prop({
    default() {
      return [
        // "image", // 插入图片
        "bold", // 粗体
        "quote", // 引用
        "underline", // 下划线
        "head", // 标题
        "list", // 列表
        "undo", // 撤销
        "redo"
      ];
    }
  })
  wangOption!: Array<object>;
  editorContent: any = "";
  // watch
  @Watch("content")
  watchContent(newVal: any) {
    if (!this.isChange) {
      // this.editorContent = this.content;
      this._setInitContent(this.content);
    }
    this.isChange = false;
  }
  mounted() {
    // 将content赋值，editorContent变化的时候，不改变父组件的content
    //this.editorContent = this.content;
    // 创建编辑器
    this.createEditor();
    // 设置内容
  }
  // 配置参数 创建编辑器
  createEditor() {
    // 初始化容器
    let editor = new E(this.$refs.toolbar, this.$refs.editor);
    editor.customConfig.menus = this.wangOption;
    editor.customConfig.zIndex = 50;
    editor.customConfig.focus = false;
    if (ZWY_CLOUD.getOS() == "iOS") {
      editor.customConfig.onblur = (html: any) => {
        this.isChange = true;
        this.$emit("update:content", html);
      };
    }

    // 方便将配置拆开写
    this.editor = editor;
    // 将富文本的html的内容变化时赋值同步到editorContent，这里的change事件将值赋值给editorContent
    this._syncContent();
    // 设置上传本地图片
    //this._setUploadLocalImg();
    // 创建编辑器
    editor.create();
    //传入内容
    this._setInitContent(this.content);
  }
  _syncContent() {
    // 设置在create之前，当内容变化的时候，将内容扔出去，同步父组件的content
    this.editor.customConfig.onchange = (html: any) => {
      this.isChange = true;
      // this.editorContent = html;
      this.$emit("update:content", html);
    };
  }
  _setInitContent(content: any) {
    this.editor.txt.html(content);
  }
  _setUploadLocalImg() {
    let that = this;
    //  do something  这里用js上传完成之后获取到图片地址
    Native.appUpload(1).then(result => {
      if (result) {
        //let url = "http://119.254.155.37:8080/img/home/zhenwutu%402x.png";
        //  调用编辑器api插入图片
        that.editor.cmd.do(
          "insertHTML",
          '<img src="' + result + '" alt="" style="max-width:100%">'
        );
        //alert(result);
      }
    });
  }
}
